import {type Fn, useEventBus} from "@vueuse/core"
import {v4 as uuidv4} from "uuid"

const EVENT_OPERATIONS_CHANGED = "loadingService:operations-changed";
const currentOperations: string[] = [];
const bus = useEventBus(EVENT_OPERATIONS_CHANGED);

function showLoadingPanel(operationId?: string) : string {
    if (operationId == null) {
        operationId = uuidv4();
    }
    currentOperations.push(operationId!);
    bus.emit({operations: currentOperations as readonly string[]})
    return operationId!;
}

function hideLoadingPanel(operationId: string) : void {
    const idx = currentOperations.findIndex(x => x === operationId);
    if (idx >= 0) {
        currentOperations.splice(idx);
        bus.emit({operations: currentOperations as readonly string[]})    
    }
    
}

function onOperationsChanged(handler: (evt: {operations : readonly string[]} ) => void) : Fn {
    return bus.on(handler as any);
}

export {showLoadingPanel, hideLoadingPanel, onOperationsChanged};
